export enum RenderAccountType {
  USER,
  STAFF,
  ACCUSED,
  PARTNER,
}

export interface IToken {
  token: string;
}
